import { create } from 'zustand';

const useLanguageStore = create((set, get) => ({
  // Current language state
  currentLanguage: 'pt',
  
  // Available languages in cycle order
  languages: ['pt', 'es', 'en'],
  
  // Language labels for display
  languageLabels: {
    pt: 'PT',
    es: 'ES',
    en: 'EN'
  },
  
  // Set specific language
  setLanguage: (language) => {
    console.log('Setting language to:', language);
    if (get().languages.includes(language)) {
      set({ currentLanguage: language });
      // Save to localStorage manually
      localStorage.setItem('language-storage', JSON.stringify({ currentLanguage: language }));
    }
  },
  
  // Cycle to next language
  cycleLanguage: () => {
    const { currentLanguage, languages } = get();
    console.log('Current language:', currentLanguage);
    console.log('Available languages:', languages);
    
    const currentIndex = languages.indexOf(currentLanguage);
    const nextIndex = (currentIndex + 1) % languages.length;
    const nextLanguage = languages[nextIndex];
    
    console.log('Cycling from', currentLanguage, 'to', nextLanguage);
    
    set({ currentLanguage: nextLanguage });
    // Save to localStorage manually
    localStorage.setItem('language-storage', JSON.stringify({ currentLanguage: nextLanguage }));
    
    return nextLanguage;
  },
  
  // Get current language label for display
  getCurrentLabel: () => {
    const { currentLanguage, languageLabels } = get();
    return languageLabels[currentLanguage];
  },
  
  // Initialize from localStorage
  initializeFromStorage: () => {
    try {
      const stored = localStorage.getItem('language-storage');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed.currentLanguage) {
          set({ currentLanguage: parsed.currentLanguage });
        }
      }
    } catch (error) {
      console.error('Error loading language from storage:', error);
    }
  }
}));

export default useLanguageStore;